module.exports = __webpack_public_path__ + "static/img/ranking_banner.dc5cd4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ranking_banner.png
// module id = C9DP
// module chunks = 1